module.exports = __webpack_public_path__ + "media/images/sp/specials/okinawa_churaumi_aquarium/logo_sola-b0126a29d04d4b2d96ab2a98df33c63c.svg";